import { useAuth0 } from '@auth0/auth0-react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { MaiChatDraftsProvider } from '~/components/maud/patients/profile/tabs/overviews/MaiChat/MaiChatDraftsContext';
import { MaiChatSessionProvider } from '~/components/maud/patients/profile/tabs/overviews/MaiChat/MaiChatSessionContext';
import { GlobalContextProvider } from '~/lib/contexts/GlobalContext';

import AuthenticatedRoutes from './AuthenticatedRoutes';
import { Path } from './constants';
import IdleTimerContainer from '../components/common/IdleTimerContainer';
import SSOLogin from '../pages/ssoLogin';

const Routes = () => {
  const { isAuthenticated } = useAuth0();

  return isAuthenticated ? (
    <GlobalContextProvider>
      <IdleTimerContainer>
        <MaiChatSessionProvider>
          <MaiChatDraftsProvider>
            <AuthenticatedRoutes />
          </MaiChatDraftsProvider>
        </MaiChatSessionProvider>
      </IdleTimerContainer>
    </GlobalContextProvider>
  ) : (
    <Switch>
      <Route component={SSOLogin} exact path={Path.LOGIN} />
      <Redirect to={Path.LOGIN} />
    </Switch>
  );
};

export default Routes;
